/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var PlusIcon64Regular = forwardRef('PlusIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M32 9.5a1.5 1.5 0 0 1 1.5 1.5v19.5H53a1.5 1.5 0 0 1 0 3H33.5V53a1.5 1.5 0 0 1-3 0V33.5H11a1.5 1.5 0 0 1 0-3h19.5V11A1.5 1.5 0 0 1 32 9.5Z" })));
});
